import { Banks } from '@factorin/domain';

import { withUrl, list, post, put, remove, ItemRequest } from '../rest';


interface CreateChangeBankItem {
    item: {
        BIK: string;
        FullName: string;
        ShortName: string;
        OGRN: string;
        INN: string;
        KPP: string;
        CorrAccount: string;
        CorrBank: string;
    };
}

const banksPart = withUrl('banks');
export const banks = {
    ...list<Banks.Bank>(banksPart()),
    create: post<CreateChangeBankItem, Banks.Bank>(
        ({ item }) => banksPart({
            body: item,
        }),
    ),
    update: put<ItemRequest & CreateChangeBankItem, Banks.Bank>(
        ({ id, item }) => banksPart({
            path: `${id}`,
            body: item,
        }),
    ),
    remove: remove<ItemRequest, void>(
        ({ id }) => banksPart({
            path: `${id}`,
        }),
    ),
};
